import { styled } from 'goober';

import { Error } from '@/ui/input/input';

export const FormFieldError = styled(Error)`
  top: calc(100% - 21px);
`;
